import {
    ICartGroup,
    ICartItem, IGroupsCheckedIds,
    ITraversedData,
    ICartItems,
} from 'mod/cart/interface';

export function getGroupIndex(groups: ICartGroup[], groupId: string): number {
    return groups.findIndex(group => group.groupId === groupId);
}

/*
export function traverseGroups(groups: ICartGroup[], itemMap: ICartItemMap = {}): ITraversedData {
    const checkedIds: string[] = [];
    const instockIds: string[] = [];
    let totalQty = 0;

    const _groups = groups.map(group => {
        let stockCounter = 0;
        let selectCounter = 0;

        const items = group.cartItemList.map(originItem => {
            const item = { ...originItem, ...itemMap[originItem.id] };
            item.isChangingQty = item.isChangingQty || false;
            item.isDeleting = item.isDeleting || false;
            item.realNum = item.num;

            if (item.stockNum > 0) {
                stockCounter++;
                instockIds.push(item.id);
                if (item.select) {
                    selectCounter++;
                    checkedIds.push(item.id);
                    totalQty += item.num;
                }
            }

            return item;
        });

        return {
            ...group,
            cartItemList: items,
            groupCheckAll: selectCounter > 0 && selectCounter === stockCounter,
            groupLoading: group.groupLoading || false,
        }
    });

    return {
        groups: _groups,
        checkedIds,
        instockIds,
        checkAll: checkedIds.length === instockIds.length,
        totalQty,
    }
}
*/

// updateItems: Record<string, Partial<ICartItem>>
export function traverseItems(items: ICartItem[]): ITraversedData {
    const checkedIds: string[] = [];
    const instockIds: string[] = [];
    let totalQty = 0; //商品总数，包含未勾选项
    let checkedTotalQty = 0; //选中的商品总数

    Object.values(items).forEach(item => {
        if (item.stockNum > 0) {
            instockIds.push(item.id);
            totalQty += item.num;
            if (item.select) {
                checkedIds.push(item.id);
                checkedTotalQty += item.num;
            }
        }
    });

    return {
        checkAll: checkedIds.length === instockIds.length && instockIds.length > 0,
        totalQty,
        checkedTotalQty,
    }
}

export function getGroupItems(group: ICartGroup, items: ICartItem[]): ICartItem[] {
    return group.itemIds.map(id => items[id] as ICartItem);
}

export function isGroupEditable(group: ICartGroup): boolean {
    return group.groupType !== 'surpriseEgg';
}

export function isCheckAll(items: ICartItem[], checkedIds: string[]): boolean {
    if (checkedIds.length === 0) {
        return false;
    }
    for (const item of items) {
        if (item && item.stockNum > 0 && !checkedIds.includes(item.id)) {
            return false
        }
    }
    return true
}

export function getGroupsCheckedIds(groups: ICartGroup[], items: ICartItem[]): IGroupsCheckedIds {
    const groupMap: IGroupsCheckedIds = {};
    groups.forEach(group => {
        const groupItems = getGroupItems(group, items);
        groupMap[group.groupId] = groupItems.filter(item => item.stockNum > 0 && item.select).map(item => item.id);
    });
    return groupMap;
}

export function mergeGroupsCheckedIds(groupMap: IGroupsCheckedIds): string[] {
    const ids = [] as string[];
    Object.values(groupMap).forEach(groupItemsIds => {
        ids.push(...groupItemsIds);
    });
    return ids;
}

/**
 * 返回需要清除选中的组的groupIds（有不能选择的group 但组内的 cartItem 被选中了）
 * @param items
 */
export function getGroupNeedClearSelectedGroupIds(items: ICartItems): string[] | false {
    let groupIds: string[] = [];
    for (const itemId in items) {
        const item = items[itemId]
        if (!item.groupCanSelect
            && item.select
            && !groupIds.includes(item.groupId)
        ) {
            groupIds.push(item.groupId);
        }
    }

    if (groupIds.length > 0) {
        return groupIds;
    }
    return false;
}